import React from 'react'
import logo from "../../../../assets/ReEngageFollowup/img/logo.png";
const Header = () => {
    return (
        <>
            <header className="brandbar py-3 pb-md-2 pb-0 text-center">
                <div className="container">
                    <a className="brandbar__logo-link">
                        <img src={logo} className="brandbar__logo" alt="tmslegal logo" />
                    </a>
                </div>
            </header>

        </>
    )
}

export default Header